import Repository from './Repository';

const resource = '/channel';

export default {
  /**
   * channel情報取得
   */
  get(channelId: string) {
    return Repository.get(`${resource}/${channelId}`);
  },
};
